import { PixRounded } from '@mui/icons-material';
import React, { Fragment } from 'react';
import { formatDateSimple } from 'utils/formatDate';
import { amountFormatter } from 'utils/formatters';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { InstallmentMobileTableProps } from 'v3/shared/components/MobileTable/InstallmentsToPayMobileTable/interface';
import { InstallmentsModal } from 'v3/shared/components/Modal/InstallmentsToPayModal';
import { PixDisplayModeModal } from 'v3/shared/components/Modal/PixDisplayModeModal';
import { PixQRCodeModal } from 'v3/shared/components/Modal/PixQRCodeModal';
import { PixSMSConfirmationModal } from 'v3/shared/components/Modal/PixSMSConfirmationModal';
import { SuccessfulPaymentModal } from 'v3/shared/components/Modal/SuccessfulPaymentModal';
import { UnsuccessfulPaymentModal } from 'v3/shared/components/Modal/UnsuccessfulPaymentModal';
import { NoItemsFound } from 'v3/shared/components/NoItemsFound';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { BodySmallBoldStyled } from 'v3/shared/typography/BodySmall/styles';
import { SubtitleMediumStyled } from 'v3/shared/typography/SubtitleMedium/styles';
import {
  MobileCardCheckboxContainer,
  MobileCardContainer,
  MobileCardFooterBoxStyled,
  MobileCardLine,
  MobileCardsWrapper,
  StyledCheckboxTermsMobile,
  TextOpacity,
} from './styles';

export const InstallmentToPayMobileTable: React.FC<InstallmentMobileTableProps> = ({
  selectedInstallments,
  unpaidItems,
  item,
  itemsToPay,
  isModalOpen,
  handleCheckboxChange,
  canInstallmentBeToggled,
  handleOpenModal,
  handleCloseModal,
  getStatusLabel,
  isPixDisplayModeModalOpen,
  handleClosePixDisplayModeModal,
  handleConfirmInstallmentsAndOpenPix,
  handleConfirmPixSendingSMS,
  isPixSMSConfirmationModalOpen,
  handleClosePixSendingSMS,
  handleConfirmPixQRCode,
  isPixQRCodeModalOpen,
  handleClosePixQRCode,
  isSuccessfulPaymentModalOpen,
  handleCloseSuccessfulPaymentModal,
  isUnsuccessfulPaymentModalOpen,
  handleCloseUnsuccessfulPaymentModal,
}) => {
  if (unpaidItems.length === 0) {
    return <NoItemsFound />;
  }

  return (
    <Fragment>
      <MobileCardsWrapper>
        {unpaidItems.map((row) => (
          <MobileCardContainer key={row.number}>
            <MobileCardLine>
              <MobileCardCheckboxContainer>
                <StyledCheckboxTermsMobile
                  checked={selectedInstallments.includes(row.number)}
                  onChange={() => handleCheckboxChange(row.number)}
                  inputProps={{ 'aria-label': `selecionar parcela ${row.number}` }}
                  disabled={!canInstallmentBeToggled(row)}
                />
                <BodySmallBoldStyled>{`Parcela ${String(row.number).padStart(2, '0')} de ${String(item.installments.length).padStart(2, '0')}`}</BodySmallBoldStyled>
              </MobileCardCheckboxContainer>
            </MobileCardLine>

            <MobileCardLine>
              <TextOpacity>
                <BodySmallRegular>Data de vencimento</BodySmallRegular>
              </TextOpacity>
              <BodySmallRegular>{formatDateSimple(row.dueDate)}</BodySmallRegular>
            </MobileCardLine>

            <MobileCardLine>
              <TextOpacity>
                <BodySmallRegular>Valor da parcela</BodySmallRegular>
              </TextOpacity>
              <BodySmallRegular>{amountFormatter(row.amount)}</BodySmallRegular>
            </MobileCardLine>

            <MobileCardLine>
              <TextOpacity>
                <BodySmallRegular>Valor atualizado</BodySmallRegular>
              </TextOpacity>
              <BodySmallRegular>{amountFormatter(row.presentAmount)}</BodySmallRegular>
            </MobileCardLine>

            <MobileCardLine>
              <TextOpacity>
                <BodySmallRegular>Status</BodySmallRegular>
              </TextOpacity>
              <BodySmallRegular>{getStatusLabel(row.paymentStatus)}</BodySmallRegular>
            </MobileCardLine>
          </MobileCardContainer>
        ))}
      </MobileCardsWrapper>

      <MobileCardFooterBoxStyled>
        <SubtitleMediumStyled>
          {`Parcelas selecionadas: ${String(itemsToPay.length).padStart(1, '0')}`}
        </SubtitleMediumStyled>
        <FlexButton
          text="Pagar com Pix"
          size="small"
          startIcon={PixRounded}
          disabled={itemsToPay.length === 0}
          handleClick={handleOpenModal}
        />
      </MobileCardFooterBoxStyled>

      <InstallmentsModal
        open={isModalOpen}
        setOpenModal={handleCloseModal}
        onConfirmAndOpenPix={handleConfirmInstallmentsAndOpenPix}
      />

      <PixDisplayModeModal
        open={isPixDisplayModeModalOpen}
        setOpenModal={handleClosePixDisplayModeModal}
        onConfirmAndOpenSMSConfirmation={handleConfirmPixSendingSMS}
        openQRCodePix={handleConfirmPixQRCode}
      />

      <PixSMSConfirmationModal
        open={isPixSMSConfirmationModalOpen}
        setOpenModal={handleClosePixSendingSMS}
        setOpenQRCodePix={() => {
          handleClosePixSendingSMS();
          handleConfirmPixQRCode();
        }}
      />

      <PixQRCodeModal
        open={isPixQRCodeModalOpen}
        setOpenModal={handleClosePixQRCode}
        setOpenQRCodeByEmail={() => {
          handleClosePixQRCode();
          handleConfirmPixSendingSMS();
        }}
      />

      <SuccessfulPaymentModal open={isSuccessfulPaymentModalOpen} setOpenModal={() => {}} />

      <UnsuccessfulPaymentModal
        open={isUnsuccessfulPaymentModalOpen}
        setOpenModal={handleCloseUnsuccessfulPaymentModal}
      />
    </Fragment>
  );
};
